import { Injectable } from "@angular/core";
import { SectionCategoryServiceType } from "./section-category.service.type";
import { getApp } from "../app";

@Injectable({
  providedIn: "root",
})
export class SectionCategoryService implements SectionCategoryServiceType {
  app = getApp((app) => {
    this.app = app;
  });

  constructor() {}
}
